import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	orderData: [],
	pagination: {
		page: 1,
		limit: 10,
		total: 0,
		totalPages: 0,
	},
	loading: false,
	statusFilter: 'all',
};

const orderDatasSlice = createSlice({
	name: "orderDatas",
	initialState,
	reducers: {
		setOrderData(state, action) {
			if (Array.isArray(action.payload)) {
				state.orderData = action.payload;
			} else if (action.payload?.data) {
				state.orderData = action.payload.data;
				state.pagination = action.payload.pagination || state.pagination;
			}
		},
		setPagination(state, action) {
			state.pagination = { ...state.pagination, ...action.payload };
		},
		setLoading(state, action) {
			state.loading = action.payload;
		},
		setStatusFilter(state, action) {
			state.statusFilter = action.payload;
		},
	},
});

export const { setOrderData, setPagination, setLoading, setStatusFilter } = orderDatasSlice.actions;
export default orderDatasSlice.reducer;
